import {createBrowserHistory} from 'history'
import {RouterStore} from '@superwf/mobx-react-router'

const browserHistory = createBrowserHistory()
export const router = new RouterStore(browserHistory)